export const cloneConfigModal = {
  close: "إغلاق",
  searchPlaceholder: "ابحث عن إقامة…",
  clearSearch: "مسح",
  bar: {
    chooseSource: "اختر إقامة المصدر",
    selected: "{count} محدَّد | {count} محدَّدة",
    selectAll: "تحديد الكل",
    clear: "إلغاء التحديد",
  },
  list: {
    loading: "جارٍ تحميل الإقامات…",
    empty: "لا توجد إقامات مطابقة.",
    unitsBadge: "{count} وحدات",
  },
  confirm: {
    sourceLabel: "المصدر المختار",
    applyToLabel: "سيُطبَّق على",
    andItsUnits: "(ومعها {count} وحدات)",
    andMore: "و{count} أخرى",
    undoWarning: "لا يمكن التراجع عن هذا الإجراء.",
  },
  footer: {
    back: "رجوع",
    cancel: "إلغاء",
    continue: "متابعة",
  },
  preview: {
    unit: "وحدة",
    listing: "إقامة",
    empty: "غير مُعَدّ.",
    loading: "جارٍ التحميل…",
  },
  confirmTitle: {
    pull: "أكِّد قبل الجلب",
    push: "راجِع قبل النسخ",
  },
  confirmLabel: {
    pulling: "جارٍ الجلب…",
    copying: "جارٍ النسخ…",
    confirmPull: "نعم، اجلب الإعدادات",
    confirmPush: "نعم، انسخ إلى {count} إقامة | نعم، انسخ إلى {count} إقامات",
  },
  intro: {
    pullLead: "أنت على وشك جلب {noun} من الإقامة التي اخترتها.",
    pullReplace: "سيحل محل ما لديك هنا الآن.",
    pullAdd: "سيُضاف إلى ما لديك هنا بالفعل.",
    pushLead: "أنت على وشك نسخ {noun} إلى {count} إقامة. | أنت على وشك نسخ {noun} إلى {count} إقامات.",
    pushReplace: "سيحل محل ما لديها الآن{scope}. | سيحل محل ما لديها الآن{scope}.",
    pushAdd: "سيُضاف إلى ما لديها بالفعل. | سيُضاف إلى ما لديها بالفعل.",
    pushScope: "، بما في ذلك إعدادات الإرسال",
  },
  attachments: {
    fileFallback: "مرفق",
    titleAlsoCopied: "تُنسخ المرفقات أيضًا",
    titlePullLose: "ستفقد المرفقات الموجودة لديك الآن",
    titlePullGain: "ستصل مرفقاتها أيضًا",
    titlePushEmpty: "ستبقى الإقامات المختارة دون مرفقات",
    noteUnknownPull: "ستحل مرفقات الإقامة التي اخترتها محل المرفقات هنا، وسيتم حذف هذه الأخيرة.",
    noteUnknownPush: "ستحل مرفقات هذه الإقامة محل مرفقات الإقامات المختارة، وسيتم حذف هذه الأخيرة.",
    notePullReplace: "سيتم حذفها وتحل محلها مرفقات الإقامة التي اخترتها.",
    notePullEmpty: "لا توجد أي مرفقات هنا الآن، لذا لن تفقد شيئًا: ستصل مرفقات الإقامة المختارة.",
    notePushEmpty: "هذه الإقامة لا تحتوي على مرفقات، لذا ستُحذف مرفقات الإقامة المختارة وتبقى دون أي مرفقات. | هذه الإقامة لا تحتوي على مرفقات، لذا ستُحذف مرفقات الإقامات المختارة وتبقى دون أي مرفقات.",
    notePushReplace: "ستُنسخ إلى الإقامة المختارة وتحل محل مرفقاتها التي سيتم حذفها. | ستُنسخ إلى الإقامات المختارة وتحل محل مرفقاتها التي سيتم حذفها.",
  },
  toast: {
    loadError: "تعذّر تحميل الإقامات",
    pullSuccess: "تم جلب الإعدادات بنجاح",
    pushSuccess: "تم نسخ الإعدادات إلى {count} إقامة | تم نسخ الإعدادات إلى {count} إقامات",
    pullError: "تعذّر جلب الإعدادات",
    pushError: "تعذّر نسخ الإعدادات",
  },
};
